import queryBuilder from '@glittr/frontend-core/src/plugins/validation/queryBuilder';
import CampaignMappingFieldResourceModel from '../../generated/types/model/resource/CampaignMappingFieldResourceModel';

export default class CampaignMappingFieldResourceViewModel extends CampaignMappingFieldResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
  schema = {
    ...queryBuilder.properties({
      appSystem1Id: { type: 'number', required: true },
      appSystem2Id: { type: 'number', required: true },
      field1Id: { type: 'string', required: true },
      field2Id: { type: 'string', required: true },
    }),
  };
}
